import axios from "axios"
import "vant/lib/index.css"
import { showToast } from "vant"
import bus from "@/lib/bus"
import { initBundleId } from "@/utils/utils"
import { useI18n } from "vue-i18n"
import { platformStore } from "@/store/index"
import { Loading } from "@/components/Loading/Loading.js"
let version = ""

function getVersion () {
  return fetch(`/version.json?t=${new Date().getTime()}`)
    .then((response) => response.json())
    .then((data) => {
      const store = platformStore()
      version = data.version
      store.setVersion(data.version)
    })
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: "/", // 所有的请求地址前缀部分
  timeout: 5000, // 请求超时时间毫秒
})
getVersion()
// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    const store = platformStore()
    config.showLoading = config.showLoading !== false
    if (config.showLoading) {
      Loading.show()
    }
    // 在发送请求之前做些什么
    if (config.url.indexOf("api.qingcigame.com") == -1) {
      config.headers["X-Version"] = version || store.version
        ; (config.headers["X-Game-Package"] = initBundleId()),
          (config.headers["Accept-Language"] = store.lang || "zh-cn")
    }

    return config
  },
  function (error) {
    // 对请求错误做些什么
    if (error.config?.showLoading) {
      Loading.hide()
    }
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    if (response.config?.showLoading) {
      Loading.hide()
    }
    if (response.data.code == 401) {
      const store = platformStore()
      bus.$emit("loginOut") //未登录调取登录接口
      store.setMobile("")
    }

    if (response.data.code == 403) {
      !response.config.hideErrorToast && showToast(response.data.message)
    }
    const dataAxios = response.data
    return dataAxios
  },
  function (error) {
    if (error.config?.showLoading) {
      Loading.hide()
    }
    showToast(useI18n("qc_sdk_netword_timeout"))
    return Promise.reject(error)
  }
)

export default service
